if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-drawer');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (this.cartNotification)
        this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification)
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          $(document).trigger('product-form-responsed', [response]);

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          // ###### @@@ 🛒 (☆▽☆) CARRITO LATERAL: se abre SOLO la 1ª vez. Después solo sube el número de la canasta @@@ ######
          // (◕‿◕) renderContents() actualiza el número Y abre el carrito → a partir de la 2ª vez le "tapamos" el open() un momento
          // ⏰ 29 DE OCTUBRE DE 2026 ⏰
          if (this.cartNotification) {
            const drawer = this.cartNotification;

            const pintar = () => {
              // ###### @@@ 🛡️ (☆▽☆) V2: la marca "ya se abrió" se pone SOLO cuando el carrito de verdad se abrió @@@ ######
              const primera = window.__idmDrawerYaAbierto !== true;
              const eraPropio = Object.prototype.hasOwnProperty.call(drawer, 'open');
              const abrirOriginal = drawer.open;

              // ###### @@@ 🙈 (☆▽☆) V3: apertura SIEMPRE en pausa mientras se pinta (adiós carrito feo por un instante) @@@ ######
              // (◕‿◕) 1ª vez: se abre DESPUÉS, ya con la lista bonita | 2ª en adelante: no se abre ゚‧₊˚✩彡
              drawer.open = function () {};

              const terminar = () => {
                // ♡ Siempre devolvemos el open() original → abrirlo MANUALMENTE sigue funcionando
                if (eraPropio) drawer.open = abrirOriginal; else delete drawer.open;
                if (!primera) return; // (＠＾◡＾) 2ª vez en adelante: solo sube el número, no abre

                // ###### @@@ (^▽^) 1ª vez: el carrito YA está pintado bonito → ahora sí lo abrimos @@@ ######
                if (!drawer.classList.contains('active')) {
                  try { abrirOriginal.call(drawer); } catch (e) { console.warn('(>⩊<) No se pudo abrir el carrito:', e); }
                }
                window.__idmDrawerYaAbierto = true; // ゚‧₊˚✩彡 AHORA sí: ya se abrió una vez
              };

              let ok = false;
              try {
                ok = drawer.renderContents(response) !== false;
              } catch (err) {
                console.warn('(>⩊<) renderContents falló:', err);
              }

              if (ok) { setTimeout(terminar, 60); return; } // ###### @@@ (◕‿◕) pintado completo → abre casi al instante @@@ ######

              // ###### @@@ 🛡️ (◕‿◕) SEGURO: la respuesta vino incompleta → le pedimos el carrito fresco a Shopify @@@ ######
              const ids = drawer.getSectionsToRender().map((s) => s.id).join(',');
              fetch(`${window.location.pathname}?sections=${ids}`)
                .then((r) => r.json())
                .then((frescas) => {
                  try { drawer.renderContents({ id: response.id, sections: frescas }); }
                  catch (e) { console.warn('(>⩊<) Tampoco se pudo con el carrito fresco:', e); }
                })
                .catch((e) => console.warn('(>⩊<) No se pudo pedir el carrito fresco:', e))
                .finally(() => setTimeout(terminar, 60)); // ###### @@@ (☆▽☆) abre solo cuando llegó el carrito fresco y bonito @@@ ######
            };

            // ###### @@@ ✈️ (◕‿◕) SINCRONÍA: si la foto voladora va en camino, esperamos a que aterrice @@@ ######
            // (>⩊<) Seguro: máximo 1.5s de espera; si la animación está apagada, pinta al instante
            let espera = 0;
            const esperarVuelo = () => {
              if (window.__idmVolando && espera < 30) {
                espera++;
                setTimeout(esperarVuelo, 50);
                return;
              }
              pintar();
            };
            esperarVuelo();
          }
          // ###### @@@ ♡＼(￣▽￣)／♡ FIN CARRITO LATERAL SOLO LA 1ª VEZ @@@ ######

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
